import {get, post, login as loginRequest, logout as logoutRequest, getToken as _getToken} from './fetch';

export const login = (email, password) => {
  return loginRequest({email, password});
}

export const validateSellerAuthorization = (oneTime = false) => {
  return post('/api/seller/authorization/validate', {oneTime: oneTime}, true);
}

export const logout = () => {
  logoutRequest();
}

export const changePassword = ({ existingPassword, password, confirmPassword }) => {
  return post('/api/password/change', { existingPassword, password, confirmPassword });
}

export const resetPasswordRequest = (email) => {
  return post('/api/password/reset/request', {email}, false);
}

export const resetPassword = (hash, params) => {
  return post(`/api/password/${hash}/reset`, params, false);
}

export const isValidResetPasswordRequest = (hash) => {
  return get(`/api/password/reset/request/${hash}/is-valid`, false);
}

export const userContext = () => {
  return get('/api/user/context');
}

export const sellerContext = () => {
  return get('/api/seller/context');
}

export const contactUsSubmit = ({ subject, message, email }) => {
  return post('/api/contact-us', { subject, message, email });
}

export const getToken = () => {
  return _getToken();
}

export const getUser = () => {
  const user = {
    firstName: 'Ali',
    lastName: 'Raza',
    businessName: 'HighCare',
    businessType: 'Vehicle Services',
    address: 'Downtown, 324',
    city: 'Newark',
    state: 2,
    zip: '13433',
    services: [2, 3]
  };
  return Promise.resolve(user);
}

export const updateProfile = (profie) => {
  return Promise.resolve()
}

export const verifyEmail = (email) => {
  return post('/api/VerifyEmail', { email }, false);
}

export const sendLoginEmail = (email , orignalURL) => {
  return post('/api/sendLoginEmail', { email , orignalURL }, false);
}